import React from "react";
import styles from './ChoosingUs.module.css';
import experience from '../../assets/home/experience.png';
import communication from '../../assets/home/communication.png';
import comfort from '../../assets/home/comfort.png';

const ChoosingUs = () => {
    return (
        <div className={styles.background}>
            
            {/* Bottom warning stripe */}
            <div className={styles.warningStripe2}></div>
            
            <div className="container overflow-hidden">
                <div className={styles.sectionHeader}>
                    <h2 data-aos='slide-right' data-aos-offset="220" className={styles.heading}>Visi</h2>
                    <div className={styles.divider}></div>
                    <p data-aos='slide-left' className={styles.sub_text}>
                        "Menjadi Mitra Terpercaya Dalam Memenuhi Kebutuhan Bangunan Anda"
                    </p>
                </div>
                
                <div className={styles.sectionHeader}>
                    <h2 data-aos='slide-right' data-aos-offset="220" className={styles.heading}>Misi</h2>
                    <div className={styles.divider}></div>
                </div>
                
                <div className={`row ${styles.missionCards}`}>
                    <div data-aos='fade-up' data-aos-delay="100" className="col-md-3">
                        <div className={styles.card}>
                            <div className={styles.iconWrapper}>
                                <img src={experience} alt="Trust" className={styles.icon} />
                            </div>
                            <h3 className={styles.logo_head}>Membangun Kepercayaan</h3>
                            <p className={styles.logo_text}>
                                Membangun hubungan berbasis kepercayaan. Tepat waktu, tepat guna, harga sesuai kualitas.
                            </p>
                        </div>
                    </div>

                    <div data-aos='fade-up' data-aos-delay="200" className="col-md-3">
                        <div className={styles.card}>
                            <div className={styles.iconWrapper}>
                                <img src={communication} alt="Innovation" className={styles.icon} />
                            </div>
                            <h3 className={styles.logo_head}>Inovasi Berkelanjutan</h3>
                            <p className={styles.logo_text}>
                                Inovasi produk dan layanan berkelanjutan.
                            </p>
                        </div>
                    </div>

                    <div data-aos='fade-up' data-aos-delay="300" className="col-md-3">
                        <div className={styles.card}>
                            <div className={styles.iconWrapper}>
                                <img src={comfort} alt="Community" className={styles.icon} />
                            </div>
                            <h3 className={styles.logo_head}>Pemberdayaan Komunitas</h3>
                            <p className={styles.logo_text}>
                                Pemberdayaan komunitas pekerja kontruksi.
                            </p>
                        </div>
                    </div>
                    
                    <div data-aos='fade-up' data-aos-delay="400" className="col-md-3">
                        <div className={styles.card}>
                            <div className={styles.iconWrapper}>
                                <img src={comfort} alt="Development" className={styles.icon} />
                            </div>
                            <h3 className={styles.logo_head}>Pengembangan Karyawan</h3>
                            <p className={styles.logo_text}>
                                Pengembangan karyawan dari sisi karakter, pengetahuan dan keterampilan.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    );
}

export default ChoosingUs;